<template>
  <div>
    <v-text-field
      v-if="field.type === 'textfield'"
      filled
      dense
      v-model="mockModel"
      :placeholder="field.placeholder"
      :hint="field.hint"
      :persistent-hint="!!field.hint"
      @input="fieldInput"
      hide-details
    />
    <v-textarea
      v-if="field.type === 'textarea'"
      filled
      dense
      v-model="mockModel"
      :placeholder="field.placeholder"
      :hint="field.hint"
      :persistent-hint="!!field.hint"
      rows="2"
      counter
      @input="fieldInput"
      hide-details
    />
    <v-text-field
      v-if="field.type === 'number'"
      filled
      dense
      type="number"
      :placeholder="field.placeholder"
      v-model="mockModel"
      :hint="field.hint"
      :persistent-hint="!!field.hint"
      @input="fieldInput"
      hide-details
    />
    <v-select
      v-if="field.type === 'select'"
      filled
      dense
      :items="field.options"
      :placeholder="field.placeholder"
      item-value="key"
      item-text="label"
      v-model="mockModel"
      :hint="field.hint"
      :persistent-hint="!!field.hint"
      @input="fieldInput"
      hide-details
    />
    <v-select
      v-if="field.type === 'multipleselect'"
      filled
      dense
      :items="field.options"
      :placeholder="field.placeholder"
      item-value="key"
      item-text="label"
      v-model="mockModel"
      multiple
      @input="fieldInput"
      hide-details
    >
      <template v-slot:selection="{ item, index }">
        <v-chip v-if="index === 0">
          <span>{{ item.label }}</span>
        </v-chip>
        <span
          v-if="index === 1"
          class="grey--text text-caption"
        >
          (+{{ mockModel.length - 1 }} others)
        </span>
      </template>
    </v-select>
    <v-switch
      v-if="field.type === 'switch' || field.type === 'toggle'"
      dense
      v-model="mockModel"
      :hint="field.hint"
      :persistent-hint="!!field.hint"
      @change="fieldInput"
      class="float-right"
    />
  </div>
</template>

<script>
	export default {
		name: "uiField",
    props: {
			field: {
				type: Object,
        required: true
      }
    },
		data() {
			return {
				mockModel: null
      }
		},
    methods: {
			fieldInput(newValue) {
				const field = this.field
        field.value = newValue
				this.$emit('fieldInput', field)
      },
      cancel() {
        this.mockModel = this.field.value
      }
    },
    created() {
			if(this.field.value !== null && typeof this.field.value !== 'undefined') {
				this.mockModel = this.field.value
			}
		}
	}
</script>

<style scoped>

</style>
